import { render, staticRenderFns } from "./NewReturnRefund.vue?vue&type=template&id=1231cc9b&scoped=true&"
import script from "./NewReturnRefund.vue?vue&type=script&lang=js&"
export * from "./NewReturnRefund.vue?vue&type=script&lang=js&"
import style0 from "./NewReturnRefund.vue?vue&type=style&index=0&id=1231cc9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231cc9b",
  null
  
)

export default component.exports